import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/* Registra as classes utilitárias de tipografia do brief no grupo
 * `font-size` do tailwind-merge, em vez do grupo `text-color` (default
 * pra qualquer `text-*` desconhecido). Sem isso, `cn('text-button',
 * 'text-white')` descarta `text-white` por achar que conflitam. */
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-display-xl',
        'text-display-md',
        'text-display-sm',
        'text-display-xs',
        'text-body-lg',
        'text-body-md',
        'text-body-md-strong',
        'text-body-sm',
        'text-body-sm-strong',
        'text-caption',
        'text-button',
        'text-eyebrow',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return customTwMerge(clsx(inputs));
}
